angular.module('SpidApp')

.constant('ProductAdapterConfig', {
  name : 'Product',
  fields : [
    {
    	local   : 'id',
    	distant : 'code_article'
    }, {
    	local   : 'label',
    	distant : 'produit'
    }, {
		local   : 'price',
		distant : 'prix'
	}, {
		local   : 'equinox',
		distant : 'equinox'
	}, {
		local   : 'code_tva',
		distant : 'code_tva'
	}, {
		local   : 'category',
		distant : 'cat_produit'
	}, {
        local   : 'barcode',
        distant : 'code_barre'
    }, {
        local   : 'date_used',
        distant : 'date_debut'
    }
  ]
})
